import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  deleteCourse,
  getCourses_vw,
} from "../../actions/manageCoursesActions";
import {
  closeLoading,
  openLoading,
} from "../../components/loadingModal/loading";

import Axios from "../../config/Axios";
import moment from "moment";
import confirm from "../../components/ConfirmModal/confirm";
import alert from "../../components/AlertModal/alertModal";
import trashIcon from "../../assets/icons/Trash_Icon.png";
import switchOff from "../../assets/box/Switch_Off.png";
import switchOn from "../../assets/box/Switch_On.png";
import Table from "../../components/Table";
import styles from "./index.module.css";
import infoIcon from "../../assets/icons/info-icon.png";
import AttendeesTableModal from "../ManageSessions/session_tables/attendees_table_modal/attendees_table_modal";

const { REACT_APP_API_URL } = process.env;

const ManageCourseTable = ({
  deleteCourse,
  getCourses_vw,
  courses,
  permissions,
}) => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    async function getAllCourses() {
      try {
        openLoading();
        await getCourses_vw();
        closeLoading();
      } catch (error) {
        console.log(error);
        alert("ERROR", error.message);
      }
    }
    getAllCourses();
  }, []);

  const handleDelete = async (idCourse) => {
    const confirmFun = await confirm(
      "Confirm",
      "Are you sure you want to delete this course?",
    );
    if (!confirmFun) return;
    try {
      await deleteCourse(idCourse);
      alert("Successfully", "Course has been deleted");
      await getCourses_vw();
    } catch (error) {
      alert("ERROR", error.message);
    }
  };

  const activeCourse = async (row) => {
    openLoading();
    try {
      await Axios.put(`${REACT_APP_API_URL}/manageCourses/setActiveCourse`, {
        active: !row.active,
        idCourse: row.idCourse,
      });
      await getCourses_vw();
    } catch (error) {
      alert("ERROR", error.response.data.message);
    } finally {
      closeLoading();
    }
  };
  const handleOpen = (e, row) => {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    setPosition({
      x: rect.left + window.scrollX,
      y: rect.bottom + window.scrollY,
    });
    setSelectedCourse(row);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setSelectedCourse(null);
  };
  const columns = useMemo(
    () => [
      {
        id: "name",
        Header: () => <div className="table-title">COURSE NAME</div>,
        header: "Name",
        grow: false,
        size: 50,
        accessorFn: (row) =>
          permissions.includes(24) || permissions.includes(25) ? (
            <Link className="link" to={`edit-course/${row.idCourse}`}>
              {row.name}
            </Link>
          ) : (
            row.name
          ),

        filterFn: (row, id, filterValue) => {
          return row.original.name
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        },
      },
      {
        id: "module",
        header: "Product",
        Header: () => <div className="table-title">MODULE</div>,
        accessorFn: (row) => row.module,
        filterFn: (row, id, filterValue) => {
          return row.original.module
            .toLowerCase()
            .includes(filterValue.toLowerCase());
        },
        grow: false,
        size: 50,
      },
      {
        id: "faculty",
        header: "Faculty",
        Header: () => <div className="table-title">OWNER</div>,
        accessorFn: (row) => (
          <div className="actions-container">
            <div>{row.numberOfDirectUsers ? row.numberOfDirectUsers : 0}</div>
            <div className={styles.rowInfoContainer}>
              <img
                src={infoIcon}
                alt="Information about attenders"
                className={styles.infoIcon}
                onClick={(e) => handleOpen(e, row)}
              />
            </div>
          </div>
        ),
        enableSorting: false,
        enableColumnFilter: false,
        grow: false,
        size: 50,
      },
      {
        id: "startDate",
        header: "Start Date",
        Header: () => <div className="table-title">START DATE</div>,
        accessorFn: (row) =>
          row.startDate
            ? moment(new Date(row.startDate)).format("MMM DD, YYYY")
            : "",
        enableSorting: false,
        grow: false,
        size: 50,
      },
      {
        id: "endDate",
        header: "End Date",
        Header: () => <div className="table-title">END DATE</div>,
        accessorFn: (row) =>
          row.endDate
            ? moment(new Date(row.endDate)).format("MMM DD, YYYY")
            : "",
        enableSorting: false,
        grow: false,
        size: 50,
      },
      {
        id: "users",
        header: "Users",
        Header: () => <div className="table-title">USERS</div>,
        accessorKey: "numberOfGroupUsers",
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 50,
      },
      {
        id: "active",
        header: "Active",
        Header: () => <div className="table-title">ACTIVE</div>,
        accessorFn: (row) => (
          <div className="actions-container">
            <img
              src={row.active ? switchOff : switchOn}
              alt="activate"
              className={styles.switch}
              onClick={() => activeCourse(row)}
            />
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 50,
      },
      {
        id: "action",
        header: "actions",
        Header: () => <div className="table-title">ACTIONS</div>,
        accessorFn: (row) => (
          <div className="actions-container">
            {(permissions.includes(24) || permissions.includes(25)) && (
              <img
                src={trashIcon}
                alt="Delete"
                className="trash_icon"
                onClick={() => handleDelete(row.idCourse)}
              />
            )}
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        grow: false,
        size: 50,
      },
    ],
    [],
  );

  return (
    <div className={styles.tableWrapper}>
      <div className="table-container">
        <Table
          data={courses}
          height="clamp(100px, 57vh, 800px)"
          columns={columns}
        />
      </div>
      {isOpen && selectedCourse && (
        <AttendeesTableModal
          users={selectedCourse.ownerUsers}
          close={handleClose}
          title="OWNERS"
          position={position}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    courses: state.manageCourses.courses_vw,
    permissions: state.usersReducer.userLogged?.permissions,
  };
};

export default connect(mapStateToProps, { getCourses_vw, deleteCourse })(
  ManageCourseTable,
);
